import { render, staticRenderFns } from "./CalculaFrete.vue?vue&type=template&id=2285002a&scoped=true&"
import script from "./CalculaFrete.vue?vue&type=script&lang=js&"
export * from "./CalculaFrete.vue?vue&type=script&lang=js&"
import style0 from "./CalculaFrete.vue?vue&type=style&index=0&id=2285002a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2285002a",
  null
  
)

export default component.exports